import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-context';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiresHireLicense?: boolean;
  requiresAdminMode?: boolean;
}

export default function ProtectedRoute({ 
  children, 
  requiresHireLicense = false,
  requiresAdminMode = false
}: ProtectedRouteProps) {
  const { user, loading, currentMode, hasLicense } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiresHireLicense && (currentMode !== 'hire' || !hasLicense('hire'))) {
    return <Navigate to="/pricing" replace />;
  }

  if (requiresAdminMode && currentMode !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}